import { interval } from 'rxjs'
import { mergeMap, map, takeUntil, filter, startWith } from 'rxjs/operators'
import { ofType, ActionsObservable, StateObservable } from 'redux-observable'
import { ReduxAction, State } from '../../../reducers/reducerType'
import usernameLib from '../../../../lib/username'
import { roomTypes } from '../../../actions/room/roomTypes'
import { setupTypes } from '../../../actions/setup/setupTypes'
import { fetchVotes } from '../../../slices/votes/votesSlice'
import { terminateGig } from '../../../actions/gig/gigActions'
import { ActionCreatorWithoutPayload } from '@reduxjs/toolkit'

const votesPolling$ = (action$: ActionsObservable<ReduxAction>, state$: StateObservable<State>) => action$.pipe(
  ofType(setupTypes.SET_ROOM),
  filter(() =>
    (
      usernameLib.isPresenter(state$.value.config.username || '') ||
      usernameLib.isObserver(state$.value.config.username || '')
    ) &&
    state$.value.config.featureFlags.votes
  ),
  mergeMap(() => {

      return interval(10000).pipe(
        takeUntil(
          action$.pipe(
            ofType<
            ReduxAction<any> | ActionCreatorWithoutPayload<string>,
            any,
            string | roomTypes.TEAR_DOWN_ROOM_SUCCESS
          >(roomTypes.TEAR_DOWN_ROOM_SUCCESS, terminateGig().type)
          )
        ),
        startWith(() => fetchVotes(state$.value.config.roomname || '')),
        map(() => fetchVotes(state$.value.config.roomname || ''))
      )

    }

  )
)

export default votesPolling$
